import type { CustomNetworkInformation } from '../types'

export function getNavigatorConnection(): CustomNetworkInformation | undefined {
  return (
    navigator.connection ||
    (navigator as any).mozConnection ||
    (navigator as any).webkitConnection
  )
}
